import type { MapGeojsonWrapperProps } from "./map-geojson.type";

import MapGeojson from "./map-geojson.component";

const MapGeojsonWrapper = ({ geojson, options }: MapGeojsonWrapperProps) => {
  if (!geojson?.length) return null;

  return geojson.map(({ key, data }) => (
    <MapGeojson key={key} geojson={data} options={options} />
  ));
};

export default MapGeojsonWrapper;
